export default __webpack_public_path__ + "static/media/figure_taiiku_suwari_back.ac1eeb59.png";